<template>
<div class="container-fluid mt-2">
  <h2>Prozess-Definition</h2>
  <div class="row mt-3">
    <div class="col-md">
      <table class="table table-striped">
        <tbody>
          <tr>
            <td><b>ID</b></td><td>{{ data.id }}</td>
          </tr>
          <tr>
            <td><b>Key</b></td><td>{{ data.key }}</td>
          </tr>
          <tr>
            <td><b>Name</b></td><td>{{ data.name }}</td>
          </tr>
          <tr>
            <td><b>Version</b></td><td>{{ data.version }}</td>
          </tr>
          <tr>
            <td><b>Definition</b></td>
            <td>
              <router-link :to="'/workflows/editor/' + data.id"><button class="btn btn-primary">Bearbeiten</button></router-link>
              <a target="_blank" :href="'/trendshop.proxy.web/rest/wf/repository/' + encodeURIComponent(data.id) + '?xml=1'"><button class="btn btn-secondary">BPMN Datei</button></a>
            </td>
          </tr>
          <tr>
            <td><b>Löschen</b></td>
            <td><button id="dver" @click="deleteVersion" class="btn btn-danger">Aktuelle Version</button></td>
          </tr>
        </tbody>
      </table>
      <b-tabs>
        <b-tab title="Diagram">
          <img v-if="data.id" style="max-width:100%;" :src="baseurl + 'rest/wf/process/diagram?id=' + encodeURIComponent(data.id)"/>
        </b-tab>
        <b-tab title="Historie">
          <div class="btn-toolbar" role="toolbar">
            <div class="input-group mt-2 mb-2">
              <button class="btn btn-secondary">Zeitraum:</button>
              <b-form-input @change="fetchHistory" id="start" type="date" v-model="history_start"></b-form-input>
              <b-form-input @change="fetchHistory" id="end" type="date" v-model="history_end"></b-form-input>
            </div>
          </div>
          <b-table @row-clicked="openHistory" ref="history" :items="history_rows" :fields="history_fields" striped hover>
          </b-table>
        </b-tab>
        <b-tab title="Daten Ansicht">
          <div class="container-fluid mt-2">
            <h5>Prozess-Daten-Vorlage</h5>
            <div class="row">
              <div class="col-md">
                <div class="btn-toolbar">
                  <button @click="savePreview" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
                </div>
                <small class="form-text text-muted">Das Template wird mit underscore.js geparsed (siehe dazu: <a href="http://underscorejs.org/#template">template</a>)</small>
                <div class="wrapper" style="height:500px;">
                  <AceEditor ref="editor" :editorId='"procResultView"' :lang="'xml'" :content="procResultView"/>
                </div>
              </div>
              <div class="col-md">
                <div class="btn-toolbar">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Prozess ID" v-model="testprocid"/>
                    <div class="input-group-append">
                      <button @click="updatePreview" class="btn btn-secondary"><font-awesome-icon icon="redo"/></button>
                    </div>
                  </div>
                </div>
                <DynamicDataView :data="testdata" :html="preview"/>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</div>
</template>

<script>
import config from '@/modules/config.js'
import router from '@/router'
import workflows from '@/modules/workflows.js'
import AceEditor from '@/components/AceEditor.vue'
import DynamicDataView from '@/components/DynamicDataView.vue'

export default {
  name: 'ProcessDefinition',
  data() {
    return {
      defid: "",
      data: {},
      history_rows: [],
      history_fields: [
        {label:"ID",key:"id"},
        {label:"DID",key:"depid"},
        {label:"Key",key:"key"},
        {label:"Start",key:"start"},
        {label:"Ende",key:"end"},
      ],
      procResultView: '',
      testprocid: '',
      lastprocid: '',
      testdata: { values: {} },
      procforms:  [],
      history_start: "",
      history_end: "",
      preview: '',
      baseurl: config.baseUrl,
    }
  },
  components: {
    AceEditor,
    DynamicDataView,
  },
  mounted: function() {

    this.defid = this.$route.params.defid;
    this.history_start = new Date().toISOString().split('T')[0];
    this.history_end   = new Date().toISOString().split('T')[0];

    this.fetchData();
  },
  methods: {
    formatDate: function(date) {
      console.log(date);
      return date.substring(8,10) + '.' + date.substring(5,7) + '.' + date.substring(0,4);
    },
    editForm(tid) {
      console.log(tid);
      console.log(this.data.key);
      router.push({name: 'ProcessFormEditor',params:{pid:this.data.key,tid:tid}});
    },
    deleteVersion: function() {
      var self = this;
      if (confirm('Aktuelle Version der Prozessdefinition löschen?')) {
        workflows.deletedef(this,this.data.depid,function() {
          self.fetchData();
          self.$bvToast.toast('Letzte Verison gelöscht',{title:'Prozessdeifnition',variant: 'success'});
        })
      }
    },
    openHistory: function(row) {
      console.log(row.id);
      router.push({name: 'ProcessHistoryEntry',params: { id: row.id }});
    },
    savePreview() {
      console.log('save preview');
      var data = { prockey: this.data.key, html: this.$refs.editor.getContent() };
      var self = this;
      workflows.saveresultpreview(this,data,function() {
        self.$bvToast.toast('Ansicht gespeichert.',{title: 'Prozess Daten Ansicht',variant:'success'})
      });
    },
    updatePreview() {
      if (this.testprocid !== this.lastprocid) {
        var self = this;
        workflows.historyEntry(this,this.testprocid,function(data) {
          console.log(data.variables);
          self.testdata = { values: data.variables };
          self.preview = self.$refs.editor.getContent();
          self.lastprocid = self.testprocid;
        });
      } else {
        console.log('up preview');
        this.preview = this.$refs.editor.getContent();
      }
    },
    fetchData: function() {
      var self = this;
      workflows.loaddef(this,this.defid,function(data) {
        self.data = data;
        self.fetchPreview();
        self.fetchHistory();
      });
      workflows.loadforms(this,this.defid,function(data) {
        self.procforms = data;
      })
    },
    fetchPreview() {
      var self = this;
      workflows.loadresultpreview(this,this.data.key,function(data) {
        console.log('got preview');
        console.log(data);
        self.preview = data.html;
        self.$refs.editor.setContent(data.html);
      });
    },
    fetchHistory: function() {
      console.log('fetch');
      var self  = this;
      var start = this.formatDate(this.history_start) + ' 0:00:00';
      var end   = this.formatDate(this.history_end) + ' 23:59:59';
      workflows.history(this,this.data.key,start,end,function(data) {
        self.history_rows = data;
      })
    }
  }
}
</script>
